export interface TimeoutEvent {
  data: TimeoutEventData;
}

interface TimeoutEventData {
  timeout?: boolean;
  warningDelay?: number;
  closeWarningModal?: boolean;
  signOut?: boolean;
}

export function bindChannelListener(
  broadcastChannel: BroadcastChannel | null,
  listener: (ev: TimeoutEvent) => void
): void {
  if (broadcastChannel) {
    broadcastChannel.onmessage = listener;
  }
}

export function broadcastToTabs(broadcastChannel: BroadcastChannel | null, message: TimeoutEventData): void {
  if (broadcastChannel) {
    broadcastChannel.postMessage(message);
  }
}

export function bindEventListeners(handleUserActivity: (event: Event) => void): void {
  window.addEventListener('resize', handleUserActivity, {capture: true});

  ['keydown', 'pointerdown', 'pointermove', 'scroll', 'wheel'].forEach((event) => {
    document.addEventListener(event, handleUserActivity, {capture: true});
  });

  document.addEventListener(
    'visibilitychange',
    (e) => {
      if (document.visibilityState === 'visible') {
        handleUserActivity(e);
      }
    },
    {capture: true}
  );
}
